import bundlesAPI from '@/app/apis/main/bundles/bundles-api.js';

export default {
	/**
	 * @return {object} bundle list
	 * @params {queryParams} - bundle types
	 * */
	async getBundles(queryParams) {
		return bundlesAPI.getBundles(queryParams);
	},

	/**
	 * @return {object} - bundle
	 * @params {bundleId}
	 * */
	async getBundleById(bundleId) {
		return bundlesAPI.getBundleById(bundleId);
	},

	/**
	 * @return {object} - bundle
	 * @params {body}
	 * */
	async getBundleByName(body) {
		return bundlesAPI.getBundleByName(body);
	},

	/**
	 * @return {object}
	 * @params {bundleId} - bundle id
	 * */
	async reactivateBundle(bundleId) {
		return bundlesAPI.putReactivateBundle(bundleId);
	},

	/**
	 * @params {bundleId}
	 * */
	async deactivateBundle(bundleId) {
		return bundlesAPI.deleteBundle(bundleId);
	},

	/**
	 * @return no content
	 * @params {bundleDetails}
	 * */
	async postAddBundle(bundleDetails) {
		return bundlesAPI.postAddBundle(bundleDetails);
	},

	/**
	 * @return no content
	 * @param {*} bundleDetails
	 * @param bundleId
	 * */
	async putUpdateBundle(bundleId, bundleDetails) {
		return bundlesAPI.putUpdateBundle(bundleId, bundleDetails);
	},

	/**
	 * @return no content
	 * @params {bundleDetails}
	 * */
	async postDogBundle(bundleDetails) {
		return bundlesAPI.postDogBundle(bundleDetails);
	},

	/**
	 * @return no content
	 * @param {*} bundleDetails
	 * @param bundleId
	 * */
	async putDogBundle(bundleId, bundleDetails) {
		return bundlesAPI.putDogBundle(bundleId, bundleDetails);
	},

	/**
	 * @param bundleId
	 * */
	async bundleDelete(bundleId) {
		return bundlesAPI.bundleDelete(bundleId);
	},

	/**
	 * @param subscriptionId
	 * */
	async deleteSubscription(subscriptionId) {
		return bundlesAPI.deleteSubscription(subscriptionId);
	}
};